import {BaseController} from "../../controllers/base-controller";
import {BaseProps} from "./base-props";
import {BaseMatchModel} from "../../../core/components/router/models/base-match-model";

export class BaseModuleProps extends BaseProps {
  controller: BaseController;
  location: Location;
  match: BaseMatchModel;
}
